module.exports = __webpack_public_path__ + "img/AneuPlan.7c788013.png";